import { render, staticRenderFns } from "./contract_sign.vue?vue&type=template&id=480f87a7&scoped=true"
import script from "./contract_sign.vue?vue&type=script&lang=js"
export * from "./contract_sign.vue?vue&type=script&lang=js"
import style0 from "./contract_sign.vue?vue&type=style&index=0&id=480f87a7&prod&lang=css"
import style1 from "./contract_sign.vue?vue&type=style&index=1&id=480f87a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480f87a7",
  null
  
)

export default component.exports